<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			<Button type="primary" @click="forbidden()" size="small" style="margin-right: 5px" class="delete" v-show="macContractState=='QRZ'">信息无误</Button>
			<Modal v-model="modal2" width="360">
				<p slot="header" style="color:#f60;text-align:center">
					<Icon type="ios-information-circle"></Icon>
					<span>修改状态</span>
				</p>
				<div style="text-align:center">
					<p>合同信息确认无误后，则进行设备安装，确认修改？</p>
				</div>
				<div slot="footer">
					<Button type="error" size="large" long :loading="modal_loading" @click="updteState()">确定</Button>
				</div>
			</Modal>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				
				
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				
				modal2: false,
				modal_loading: false,
				macContractState:'',
				deleteId:'',
				loading:false,
				total:100,
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '订单编号',
						key: 'contractCode'
					},
					{
						title: '设备编号',
						key: 'macDetailsCode'
					},
					{
						title: '设备名称',
						key: 'macDetailsName'
					},
					{
						title: '单价',
						key: 'unitPrice',
						render: (h, params) => {
						    return h("div",params.row.unitPrice/100)
						}
					},
					{
						title: '设备数量',
						key: 'number'
						
					},
					{
						title: '已安装数量',
						key: 'installNumber'
					},
					{
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				data6: [
					{
						/* id: '1',
						name: '饮料',
						state: '启用',
						createdTime: '2010-10-10',
						cz: '' */
					}
				],
				query:{
					page:0,
					size:10,
					orderId:''
				}

			}
		},
		methods: {
			forbidden(id){
				this.deleteId=this.query.orderId
				this.modal2=true
			},
			updteState(){
				let _this=this
				if(this.deleteId==""){
					this.$Message.error('参数错误，请刷新页面后重试!');
				}else{
					this.modal_loading = false;
					this.modal2 = false;
					
					http.http({
					    //这里是你自己的请求方式、url和data参数
					    method: 'post',
					    url: http.url + '/fin/report/contract/update/state',
					    data: {id:_this.deleteId},
						_this: _this,
						success: function(data) {
							_this.$Message.success('修改成功！！！');
							_this.ajaxPage()
							_this.macContractState='AZZ'
						}
					    //假设后台需要的是表单数据这里你就可以更改
					  })
					
				}
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			update(id) { //修改
				this.$router.push({
					name: 'jm/platform/macOrder/details/update',
					query:{
						id:id
					}
				})
			},
			add() {
				this.$router.push({
					name: 'jm/platform/macOrder/details/add',
					query:{
						orderId:this.query.orderId
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/contract/details/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
	    components: {
	    	page
	    },
		created(){
			this.query.orderId=this.$route.query.id
			this.macContractState=this.$route.query.macContractState
			this.ajaxPage()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/alliance/macOrder/details/list.vue